(function () {
  const header = document.querySelector('[data-ll-header]');
  if (!header) return;

  const mobileToggle = header.querySelector('[data-ll-mobile-toggle]');
  const mobilePanel = header.querySelector('[data-ll-mobile-panel]');
  const jewelryToggle = header.querySelector('[data-ll-mobile-jewelry]');
  const jewelryPanel = header.querySelector('[data-ll-mobile-collections]');
  const megaItem = header.querySelector('[data-ll-mega]');
  const megaTrigger = header.querySelector('[data-ll-mega-trigger]');

  /* Sticky PLP filters (bracelets/necklaces/earrings) sit below the live header height. */
  function setStickyHeaderHeight() {
    const group =
      document.querySelector('.shopify-section-group-header-group') || header;
    if (!group) return;
    document.documentElement.style.setProperty(
      '--ll-sticky-header-height',
      Math.ceil(group.getBoundingClientRect().height) + 'px'
    );
  }

  setStickyHeaderHeight();
  window.addEventListener('resize', setStickyHeaderHeight);
  if (typeof ResizeObserver !== 'undefined') {
    const group =
      document.querySelector('.shopify-section-group-header-group') || header;
    new ResizeObserver(setStickyHeaderHeight).observe(group);
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function () {
      const open = header.classList.toggle('is-mobile-open');
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open && jewelryPanel && jewelryToggle) {
        jewelryPanel.classList.remove('is-open');
        jewelryToggle.classList.remove('is-open');
        jewelryToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  if (jewelryToggle && jewelryPanel) {
    jewelryToggle.addEventListener('click', function () {
      const open = jewelryPanel.classList.toggle('is-open');
      jewelryToggle.classList.toggle('is-open', open);
      jewelryToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  if (megaItem && megaTrigger) {
    var megaCloseTimer;

    function canHoverMega() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function setMegaOpen(open) {
      megaItem.classList.toggle('is-open', open);
      megaTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    megaItem.addEventListener('mouseenter', function () {
      if (!canHoverMega()) return;
      clearTimeout(megaCloseTimer);
      setMegaOpen(true);
    });

    megaItem.addEventListener('mouseleave', function () {
      if (!canHoverMega()) return;
      clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(function () {
        setMegaOpen(false);
      }, 120);
    });

    megaTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (canHoverMega()) return;
      setMegaOpen(!megaItem.classList.contains('is-open'));
    });

    document.addEventListener('click', function (e) {
      if (!megaItem.contains(e.target)) setMegaOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setMegaOpen(false);
    });
  }

  /* Predictive search dropdown height inside fullscreen search modal */
  customElements.whenDefined('predictive-search').then(function () {
    const Klass = customElements.get('predictive-search');
    if (Klass.prototype.__llPatchedMaxHeight) return;
    Klass.prototype.__llPatchedMaxHeight = true;
    const originalGetMax = Klass.prototype.getResultsMaxHeight;
    Klass.prototype.getResultsMaxHeight = function () {
      if (this.closest('.ll-header__search-wrap') && this.input) {
        const inputRect = this.input.getBoundingClientRect();
        this.resultsMaxHeight = Math.max(200, window.innerHeight - inputRect.bottom - 24);
        return this.resultsMaxHeight;
      }
      return originalGetMax.call(this);
    };
  });
})();
